export default __webpack_public_path__ + "static/media/Animations_Clock2.38ab3986.svg";